export function toThousands(num) {
  var num = (num || 0).toString(), result = '';
  while (num.length > 3) {
      result = ',' + num.slice(-3) + result;
      num = num.slice(0, num.length - 3);
  }
  if (num) { result = num + result; }
  return result;
}


// 企业营收、投产达产情况统计
export const echartBar10 = {
  title: {
      text: '近5年统计数据',
      subtext: '单位：万元'
  },
  tooltip: {
      trigger: 'axis',
      axisPointer: {
          type: 'shadow'
      },
      formatter: function (params) {
          let a = params[0].data;
          let b = params[1].data;
          let a_v = a.value > 999 ? toThousands(a.value) : a.value;
          let b_v = b.value > 999 ? toThousands(b.value) : b.value;

          return `${a.year}年<br>营收计划: ${a_v + (a.value > 0 ? '万元' : '')}<br>营收达成: ${b_v + (b.value > 0 ? '万元' : '')}`;
          // return "{b}<br>{a0}: {c0}万元<br>{a1}: {c1}万元"
      }
  },
  legend: {
      data: ['营收计划', '营收达成']
  },
  grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
  },
  xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01]
  },
  yAxis: {
      type: 'category',
      data: []
  },
  series: [
      {
          name: '营收计划',
          type: 'bar',
          data: [],
          itemStyle: {
              color: '#E87C25'
          }
      },
      {
          name: '营收达成',
          type: 'bar',
          data: [],
          itemStyle: {
              color: '#27727B'
          }
      }
  ],

}